import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import { collection, addDoc } from "firebase/firestore";
import { db } from "./firebase";

const CreateClassDialog = ({ open, onClose, onClassCreated, userId }) => {
  const [className, setClassName] = useState("");
  const [description, setDescription] = useState("");
  const [studentCount, setStudentCount] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setIsSubmitting(true);

    try {
      const docRef = await addDoc(collection(db, "classes"), {
        name: className,
        description: description,
        studentCount: parseInt(studentCount),
        userId: userId,
        createdAt: new Date(),
      });

      onClassCreated({
        id: docRef.id,
        name: className,
        description,
        studentCount: parseInt(studentCount),
      });
      handleClose();
    } catch (error) {
      console.error("Error creating class:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setClassName("");
    setDescription("");
    setStudentCount("");
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { p: 2 },
      }}
    >
      <DialogTitle sx={{ fontWeight: "bold" }}>Skapa ny klass</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
          <TextField
            label="Namn"
            value={className}
            onChange={(e) => setClassName(e.target.value)}
            fullWidth
            placeholder="t.ex. Klass 3A"
            required
            autoFocus
            onKeyPress={(e) => {
              if (e.key === "Enter" && className) {
                e.preventDefault();
                handleSubmit();
              }
            }}
          />
          <TextField
            label="Beskrivning"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            fullWidth
            placeholder="Valfri beskrivning av klassen"
            multiline
            rows={2}
            sx={{ display: "none" }}
          />
          <TextField
            label="Antal elever"
            type="number"
            value={studentCount}
            onChange={(e) => setStudentCount(e.target.value)}
            fullWidth
            placeholder="t.ex. 25"
            sx={{ display: "none" }}
            inputProps={{ min: "1" }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="print" onClick={handleClose}>
          Avbryt
        </Button>
        <Button
          onClick={handleSubmit}
          variant="purp"
          disabled={isSubmitting || !className}
          startIcon={
            isSubmitting ? (
              <CircularProgress sx={{ color: "white" }} size={20} />
            ) : null
          }
        >
          {isSubmitting ? "Sparar..." : "Spara"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateClassDialog;
